import React from 'react'

export const BodyCopy = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  return (
    <section className="bg-default-900 py-24">
      <div className="container mx-auto grid grid-cols-12">
        <div className="legal col-span-12 mt-8 leading-relaxed md:col-span-8 md:col-start-2">
          {children}
        </div>
      </div>
    </section>
  )
}
